// hooks/billing/useOrgSubscription.js
import { useCallback, useEffect, useState } from 'react';
import BillingService from '../../services/billing.service';

/**
 * useOrgSubscription — `GET /organizations/{orgId}/subscription`.
 *
 * Returns the full Enterprise subscription row (allowance, anchor,
 * last reset, sub id, timestamps). Same Enterprise-only constraint
 * as useOrgBalance — caller checks NOT_AN_ENTERPRISE_ORG.
 *
 * @param {string} organizationId
 * @param {Object} [options]
 * @param {boolean} [options.auto=true]
 */
export function useOrgSubscription(organizationId, { auto = true } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(Boolean(auto && organizationId));
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    if (!organizationId) return;
    setLoading(true);
    setError(null);
    const result = await BillingService.getOrgSubscription(organizationId);
    if (result.success) {
      setData(result.data);
    } else {
      setError(result);
    }
    setLoading(false);
  }, [organizationId]);

  useEffect(() => {
    if (auto && organizationId) {
      refetch();
    } else if (!organizationId) {
      setData(null);
      setError(null);
      setLoading(false);
    }
  }, [auto, organizationId, refetch]);

  return { data, loading, error, refetch };
}

export default useOrgSubscription;
